import {
  ElementRef, Component, ViewChild, OnInit, Input,
  Output, EventEmitter, AfterViewInit, HostListener, OnDestroy, NgZone
} from '@angular/core';

import { EChartsOptions } from './echarts-options';
import { EChartsService } from './echarts.service';

declare var echarts: any;
@Component({
  selector: 'bgc-echarts',
  template:`<div #host [ngStyle]="style"></div>
`,
  styles: [``],
  providers: [EChartsService]
})
export class BgEChartsComponent implements AfterViewInit, OnDestroy {
  private echarts: any = require('echarts');
  private _eCharts: any;
  private _option: EChartsOptions;
  private _gourp: string;
  private currentWindowWidth = null;
  @Input() style: any;
  @Input() theme: Object | string = 'default';
  @Input()
  public set option(value: EChartsOptions) {
    this._option = value;
    if (this._eCharts) {
      this._eCharts.setOption(value);
      this.onOptionChange.emit(value);
    }
  }

  public get option(): EChartsOptions {
    return this._option;
  }

  @Input()
  public set group(value: string) {
    this._gourp = value;
    this.setGroup();
  }

  public get group(): string {
    return this._gourp;
  }

  @Output() onBeforeInit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAfterInit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOptionChange: EventEmitter<any> = new EventEmitter<any>();

  // chart events:
  @Output() chartClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() chartDblClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() chartMouseDown: EventEmitter<any> = new EventEmitter<any>();
  @Output() chartMouseUp: EventEmitter<any> = new EventEmitter<any>();
  @Output() chartMouseOver: EventEmitter<any> = new EventEmitter<any>();
  @Output() chartMouseOut: EventEmitter<any> = new EventEmitter<any>();
  @Output() chartGlobalOut: EventEmitter<any> = new EventEmitter<any>();
  @Output() chartContextMenu: EventEmitter<any> = new EventEmitter<any>();
  @Output() chartDataZoom: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('host') host: ElementRef;

  private setGroup(): void {
    this._eCharts && (typeof this._gourp !== 'undefined') && ((<any>this._eCharts).group = this._gourp);
  }

  init(): void {
    if (!this._eCharts) {
      this.ngZone.runOutsideAngular(() => {
        this.onBeforeInit.emit();
        this._eCharts = <any>(this.echarts.init(this.host.nativeElement, this.theme, this.style ? {} : { 'height': '400px' }));
        this.ecs.setCharts(this._eCharts);
        this.onAfterInit.emit();
        // this.ecs.showLoading();
        this.option && this._eCharts.setOption(this.option);
        this.registerEvents(this._eCharts);
        this.setGroup();
        // this.ecs.hideLoading();
        this.currentWindowWidth = window.innerWidth;
      });
    } else {
      this.option && this._eCharts.setOption(this.option);
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any): void {
    if (event.target.innerWidth !== this.currentWindowWidth) {
      this.currentWindowWidth = event.target.innerWidth;
      if (this._eCharts) {
        this.ecs.resize();
      }
    }
  }

  public connect(group: string): void {
    this.echarts.connect(group);
  }

  public disconnect(group: string): void {
    (<any>this.echarts).disconnect(group);
  }

  public dispose(): void {
    this._eCharts.dispose();
    this._eCharts = null;
  }

  private registerEvents(eCharts: any): void {
    if (eCharts) {
      // register mouse events:
      this.ecs.on('click', (e: any) => { this.chartClick.emit(e) });
      this.ecs.on('dblClick', (e: any) => { this.chartDblClick.emit(e) });
      this.ecs.on('mousedown', (e: any) => { this.chartMouseDown.emit(e) });
      this.ecs.on('mouseup', (e: any) => { this.chartMouseUp.emit(e) });
      this.ecs.on('mouseover', (e: any) => { this.chartMouseOver.emit(e) });
      this.ecs.on('mouseout', (e: any) => { this.chartMouseOut.emit(e) });
      this.ecs.on('globalout', (e: any) => { this.chartGlobalOut.emit(e) });
      this.ecs.on('contextmenu', (e: any) => { this.chartContextMenu.emit(e) });
      // other events;
      this.ecs.on('dataZoom', (e: any) => { this.chartDataZoom.emit(e) });
    }
  }

  constructor(private el: ElementRef, private ngZone: NgZone, private ecs: EChartsService) { }

  ngAfterViewInit(): void {
    this.init();
  }

  ngOnDestroy(): void {
    this.dispose();
  }
}
